import type { Point } from "./dcel";

export function pointInPolygon(point: Point, vs: Point[]) {
  return windingNumber(point, vs) !== 0;
}

function windingNumber(point: Point, vs: Point[]) {
  const x = point[0];
  const y = point[1];
  let wn = 0;

  for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
    const xi = vs[i][0],
      yi = vs[i][1];
    const xj = vs[j][0],
      yj = vs[j][1];

    if (yj <= y) {
      if (yi > y) {
        if (isLeft([xj, yj], [xi, yi], [x, y]) > 0) {
          wn++;
        }
      }
    } else {
      if (yi <= y) {
        if (isLeft([xj, yj], [xi, yi], [x, y]) < 0) {
          wn--;
        }
      }
    }
  }
  return wn;
}

function isLeft(P0: Point, P1: Point, P2: Point) {
  return (P1[0] - P0[0]) * (P2[1] - P0[1]) - (P2[0] - P0[0]) * (P1[1] - P0[1]);
}
